module.exports = __webpack_public_path__ + "img/thumb_31.77135597.jpg";